module.exports = __webpack_public_path__ + "static/media/Effra-Regular.6ce5607d.woff";